
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { LayerImage } from "./types";

export function useLayerImages() {
  return useQuery({
    queryKey: ['layer-images'],
    queryFn: async () => {
      console.log('Fetching layer images...');
      const { data, error } = await supabase
        .from('layer_images')
        .select('*')
        .order('title', { ascending: true });

      if (error) {
        console.error('Error fetching layer images:', error);
        throw error;
      }
      
      console.log('Fetched layer images:', data);
      return data as LayerImage[];
    },
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
}
